/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../../map-command.class';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { isEqual } from 'lodash-es';

export class SelectWithinBufferCommand extends MapCommand {

    constructor() {
        super();
    }

    invoke() {
        this.deps['bufferService'].selectWithinBuffer();
        this.deactivate$.next();
    }

    setDependencies(deps: { [p: string]: any }) {
        super.setDependencies(deps);
        this.shouldDisable$ = this.deps['bufferService']
            .hasBuffer$.pipe(
                distinctUntilChanged(isEqual),
                map(hasBuffer => !hasBuffer)
            );

    }
}
